import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c8f6fece&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f6fece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8f6fece')) {
      api.createRecord('c8f6fece', component.options)
    } else {
      api.reload('c8f6fece', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c8f6fece&scoped=true", function () {
      api.rerender('c8f6fece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceAdjustment/index.vue"
export default component.exports